import Review from "../../ProductView/common/Review";
const reviews = [
    {
        postedBy: "Lokesh Sain",
        rating: 5,
        title: "Awesome",
        description: "This is the one of the one best earbuds in any earbuds and sound quality and bass is very good 👍 This earbuds better than noice and boat earbuds really trust me one of the one best earbuds!! Thank-you Flipkart and oppo🤗🤗👏🤗",
        userId: 123,
        id: 111,
    },
    {
        postedBy: "Lokesh Sain",
        rating: 3,
        title: "Does the job",
        description: "One of the best tws I have ever bought, I personally like the clear vocals feature ,must buy this sound quality is awesome",
        userId: 123,
        id: 121,
    }, {
        postedBy: "Lokesh Sain",
        rating: 4,
        title: "Good quality product",
        description: "Osm product 😍😍",
        userId: 123,
        id: 131,
    }
]
function UserReviews() {
    return (
        <div className="px-6 py-5 space-y-2">
            {reviews.map((review, index) => (
                <div key={review?.id} className="border-[1px] border-gray-200 rounded-md p-4">
                    <Review classname="!py-0" review={review} key={review.title + index} showBottom={false} />
                </div>
            ))}

        </div>

    );
}

export default UserReviews;

<div className="flex py-10 justify-center flex-col basis-full items-center space-y-8">
    <img src="/review-rating.svg" alt="no review-rating" className="w-52" />
    <div className="space-y-2 text-center">
        <p className="text-xl font-medium tracking-tight text-gray-900">No Reviews & Ratings</p>
        <p className="text-sm font-medium tracking-tight text-gray-600">You have not rated or reviewed any product yet!</p>
    </div>
</div> 